import { api } from '@/lib/axios';
import {
  Venue,
  CreateVenueDto,
  UpdateVenueDto,
  CheckAvailabilityDto,
  CalculatePriceDto,
  PriceCalculationResult,
  AvailabilityResult,
} from '@caruso/types';

export const venuesService = {
  async getAll(onlyActive = true): Promise<Venue[]> {
    const response = await api.get<Venue[]>('/venues', {
      params: { onlyActive },
    });
    return response.data;
  },

  async getById(id: string): Promise<Venue> {
    const response = await api.get<Venue>(`/venues/${id}`);
    return response.data;
  },

  async create(data: CreateVenueDto): Promise<Venue> {
    const response = await api.post<Venue>('/venues', data);
    return response.data;
  },

  async update(id: string, data: UpdateVenueDto): Promise<Venue> {
    const response = await api.patch<Venue>(`/venues/${id}`, data);
    return response.data;
  },

  async delete(id: string): Promise<void> {
    await api.delete(`/venues/${id}`);
  },

  async checkAvailability(
    id: string,
    data: CheckAvailabilityDto,
  ): Promise<AvailabilityResult> {
    const response = await api.post<AvailabilityResult>(
      `/venues/${id}/check-availability`,
      data,
    );
    return response.data;
  },

  async calculatePrice(
    id: string,
    data: CalculatePriceDto,
  ): Promise<PriceCalculationResult> {
    const response = await api.post<PriceCalculationResult>(
      `/venues/${id}/calculate-price`,
      data,
    );
    return response.data;
  },

  async getUpcomingReservations(days = 30): Promise<Venue[]> {
    const response = await api.get<Venue[]>('/venues/upcoming-reservations', {
      params: { days },
    });
    return response.data;
  },
};
